import { Component, type ErrorInfo, type ReactNode } from 'react'

interface PublicErrorBoundaryProps {
  readonly children: ReactNode
}

interface PublicErrorBoundaryState {
  readonly error: Error | null
}

export class PublicErrorBoundary extends Component<
  PublicErrorBoundaryProps,
  PublicErrorBoundaryState
> {
  state: PublicErrorBoundaryState = { error: null }

  static getDerivedStateFromError(error: Error): PublicErrorBoundaryState {
    return { error }
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
    if (import.meta.env.DEV) {
      console.error('PublicErrorBoundary caught an error:', error, errorInfo.componentStack)
    }
  }

  render(): ReactNode {
    if (!this.state.error) return this.props.children

    return (
      <main className="flex min-h-screen items-center justify-center bg-background px-4">
        <div className="max-w-md text-center">
          <h1 className="text-2xl font-semibold text-foreground">Unable to load this page</h1>
          <p className="mt-3 text-muted-foreground">
            Refresh the page. If the problem continues, contact AI Commerce Ready support.
          </p>
          <button
            type="button"
            onClick={() => window.location.reload()}
            className="mt-6 inline-flex h-10 items-center justify-center rounded-md bg-primary px-4 text-sm font-medium text-primary-foreground transition-colors hover:bg-primary/90 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
          >
            Refresh Page
          </button>
        </div>
      </main>
    )
  }
}
